module.exports = __webpack_public_path__ + "img/pao-de-acucar.89819c99.jpg";